import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-email-template-modal',
  imports: [],
  templateUrl: './email-template-modal.html',
  styleUrl: './email-template-modal.scss',
})
export class EmailTemplateModalComponent {
  @ViewChild('modalRef') modalElement!: ElementRef;
  @ViewChild('emailtemplatecontent') emailtemplatecontent!: ElementRef;
  @Output() closePopup = new EventEmitter<void>();
  private modalInstance: any;

  // ngAfterViewInit() {

  // open() {

  // close() {
  
  copyTemplate() {
    const content = this.emailtemplatecontent?.nativeElement;
  
    // Extract clean text (preserves line breaks)
    const text = content?.innerText;
  
    navigator.clipboard.writeText(text).then(() => {
      alert("Template copied to clipboard!");
    }).catch(err => {
      console.error("Copy failed:", err);
    });
  }
  onClose() {
    this.closePopup.emit()

  }
}
